<div class="dialog-header d-flex justify-content-between align-items-center p-3 border-bottom">
  <div class="d-flex align-items-center">
    <div class="warning-icon-circle me-3">
      <mat-icon class="warning-icon">warning_amber</mat-icon>
    </div>
    <div>
      <h3 class="dialog-title mb-0">Already Assigned Codes Found</h3>
      <div class="dialog-subtitle">Some codes in your selection are already assigned to products</div>
    </div>
  </div>
  <button mat-icon-button (click)="onCancel()" aria-label="Close" class="text-muted">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="p-3" style="max-height: 60vh; overflow-y: auto;">
  <!-- Alert Banner -->
  <div class="alert alert-theme-warning d-flex align-items-center mb-3 p-3 rounded" role="alert">
    <div>
      <strong>{{ data.usedCount }}</strong> of <strong>{{ data.totalRequested }}</strong> codes are already assigned.
      <span *ngIf="data.availableCount > 0">
        You can still assign the remaining <strong>{{ data.availableCount }}</strong> unused code(s).
      </span>
      <span *ngIf="data.availableCount === 0">
        None of the requested codes are available.
      </span>
    </div>
  </div>

  <!-- Assigned Codes List/Table -->
  <div class="card mb-3 border theme-table-card">
    <div class="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center">
      <span class="fw-semibold fs-13 text-secondary text-uppercase tracking-wider">
        Already Assigned Codes ({{ data.alreadyUsedCodes ? data.alreadyUsedCodes.length : 0 }})
      </span>
    </div>
    <div class="table-responsive" style="max-height: 220px; overflow-y: auto;">
      <table class="table table-sm table-hover mb-0 fs-13 align-middle">
        <thead class="theme-table-head sticky-top">
          <tr>
            <th scope="col" style="width: 70px;">Seq #</th>
            <th scope="col">Barcode</th>
            <th scope="col">Assigned To</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data.alreadyUsedCodes">
            <td>
              <span class="seq-badge">#{{ item.seqNo }}</span>
            </td>
            <td>
              <code class="theme-barcode-code">{{ item.barcode }}</code>
            </td>
            <td>
              <span class="text-danger fw-semibold">{{ item.productName || 'Assigned' }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Confirmation Prompt -->
  <div *ngIf="data.availableCount > 0" class="confirmation-box p-3 rounded">
    <div class="d-flex align-items-center">
      <mat-icon class="theme-icon-primary me-2">help_outline</mat-icon>
      <div class="fw-semibold text-dark fs-14">
        Do you want to add the remaining <strong>{{ data.availableCount }}</strong> unused code(s) and ignore the already assigned ones?
      </div>
    </div>
  </div>
</mat-dialog-content>

<div class="dialog-footer d-flex justify-content-end align-items-center gap-2 p-3 border-top">
  <button mat-button type="button" class="btn-dialog-cancel" (click)="onCancel()">
    Cancel
  </button>
  <button
    *ngIf="data.availableCount > 0"
    mat-raised-button
    type="button"
    class="btn-theme-confirm"
    (click)="onConfirm()">
    <mat-icon class="me-1" style="height:18px;width:18px;font-size:18px;line-height:18px;">check_circle</mat-icon>
    Yes, Add Other Codes ({{ data.availableCount }})
  </button>
</div>
